export default __webpack_public_path__ + "static/media/loading.accf5e9c.gif";